import { createRoutine } from 'redux-saga-routines';

export const getSeedRefundRoutine = createRoutine('seed/REFUND');

export const getSeedUnstakeRoutine = createRoutine('seed/UNSTAKE_SEED');

export const getSeedStakeRoutine = createRoutine('seed/STAKE_SEED');

export const getSeedBalanceRoutine = createRoutine('seed/GET_SEED_BALANCE');
